import type { PlatformBridge } from "@acto/taskpane/core/platform/messaging/bridge";
import type { PlatformPlugin } from "@acto/taskpane/core/platform/PlatformPlugin";
import type { PlatformEnv } from "@acto/taskpane/core/platform/runtime/env";

interface SalesforceContextData {
  accountId?: string;
  accountName?: string;
  sourceObject?: string;
  sourceRecordId?: string;
}

interface SalesforceContextMessage {
  type: "acto.salesforceContext";
  data: SalesforceContextData;
}

const CONTEXT_REQUEST_TYPE = "acto.requestSalesforceContext" as const;
let listenerRegistered = false;

function isSalesforceContextMessage(value: unknown): value is SalesforceContextMessage {
  if (!value || typeof value !== "object") return false;
  const msg = value as Partial<SalesforceContextMessage>;
  return msg.type === "acto.salesforceContext" && !!msg.data && typeof msg.data === "object";
}

const SalesforcePlugin: PlatformPlugin<void> = {
  name: "salesforce",

  async canBoot(env: PlatformEnv) {
    return env.platform?.toLowerCase() === "salesforce";
  },

  async boot(_env: PlatformEnv) {
    void _env;
  },

  registerMessaging(bridge: PlatformBridge) {
    if (typeof window === "undefined") return;
    if (listenerRegistered) return;

    const handler = (event: MessageEvent<unknown>) => {
      if (!isSalesforceContextMessage(event.data)) return;

      const { accountId } = event.data.data;
      if (!accountId) return;

      bridge.dispatch({
        type: "crm.entity",
        payload: { crmId: accountId },
      });
    };

    listenerRegistered = true;
    window.addEventListener("message", handler);

    if (window.top && window.top !== window) {
      window.top.postMessage({ type: CONTEXT_REQUEST_TYPE }, "*");
    }
  },
};

export default SalesforcePlugin;
